if(!Util) { function Util () {} };

Util.addClass = function(el, className) {
    var classList = className.split(' ');
    el.classList.add(classList[0]);
    if (classList.length > 1) Util.addClass(el, classList.slice(1).join(' '));
};

Util.removeClass = function(el, className) {
    var classList = className.split(' ');
    el.classList.remove(classList[0]);
    if (classList.length > 1) Util.removeClass(el, classList.slice(1).join(' '));
};

Util.addClass = function(el, className) {
    var classList = className.split(' ');
    el.classList.add(classList[0]);
    if (classList.length > 1) Util.addClass(el, classList.slice(1).join(' '));
};

Util.toggleClass = function(el, className, bool) {
    if(bool) Util.addClass(el, className);
    else Util.removeClass(el, className);
};

Util.setAttributes = function(el, attrs) {
    for(var key in attrs) {
        el.setAttribute(key, attrs[key]);
    }
};

Util.hasClass = function(el, className) {
    return el.classList.contains(className);
};

Util.getChildrenByClassName = function(el, className) {
    var children = el.children,
        childrenByClass = [];
    for (var i = 0; i < children.length; i++) {
        if (Util.hasClass(children[i], className)) childrenByClass.push(children[i]);
    }
    return childrenByClass;
};

Util.getIndexInArray = function(array, el) {
    return Array.prototype.indexOf.call(array, el);
};

(function() {

    var Steps = function(element) {

        this.element = element;
        this.stepList = this.element.getElementsByClassName('js-steps__controls')[0];
        this.listItems = this.stepList.getElementsByTagName('li');
        this.triggers = this.stepList.getElementsByTagName('a');
        this.panelsList = this.element.getElementsByClassName('js-steps__panels')[0];
        this.panels = Util.getChildrenByClassName(this.panelsList, 'js-steps__panel');
        this.hideClass = this.element.getAttribute('data-hide-panel-class') ? this.element.getAttribute('data-hide-panel-class') : 'hide';
        this.customShowClass = this.element.getAttribute('data-show-panel-class') ? this.element.getAttribute('data-show-panel-class') : false;
        this.layout = this.element.getAttribute('data-tabs-layout') ? this.element.getAttribute('data-tabs-layout') : 'horizontal';

        this.initTab();
    };

    Steps.prototype.initTab = function() {

        this.stepList.setAttribute('role', 'tablist');
        
        Util.addClass(this.element, 'tabs--no-interaction');

        for( var i = 0; i < this.triggers.length; i++) {

            var bool = (i == 0);

            var panelId = this.panels[i].getAttribute('id');
    
            this.listItems[i].setAttribute('role', 'presentation');

            Util.setAttributes(this.triggers[i], {'role': 'tab', 'aria-selected': bool, 'aria-controls': panelId, 'id': 'tab-'+panelId});

            Util.addClass(this.triggers[i], 'js-steps__trigger');

            Util.setAttributes(this.panels[i], {'role': 'tabpanel', 'aria-labelledby': 'tab-'+panelId});

            Util.toggleClass(this.panels[i], this.hideClass, !bool)

            if (bool && this.customShowClass) {
                Util.addClass(this.panels[i], this.customShowClass);
            }

            if(!bool) {
                this.triggers[i].setAttribute('tabindex', '-1');
            }
        }

        this.initTabEvents();
    };

    Steps.prototype.initTabEvents = function() {

        var self = this;

        this.stepList.addEventListener('click', function(event) {

            if(event.target.closest('.js-steps__trigger')) {
                self.triggerTab(event.target.closest('.js-steps__trigger'), event);
            } 
        });

        this.stepList.addEventListener('keydown', function(event) {

            if( !event.target.closest('.js-steps__trigger') ) {
                return;
            }
            
            if(navigateNext(event, self.layout)) 
            {
                event.preventDefault();

                self.selectNewTab('next');

            } else if(navigatePrev(event, self.layout)) {

                event.preventDefault();

                self.selectNewTab('prev');
            }
        });
    };

    Steps.prototype.setProgress = function (index) {

        for (var i = 0; i < this.stepList.children.length; i++) {
            Util.removeClass(this.stepList.children[i].firstElementChild, 'tabs-nav-v2__item--complete');
        }

        for (var i = 0; i < index; i++) {
            Util.addClass(this.stepList.children[i].firstElementChild, 'tabs-nav-v2__item--complete');
        }
    };

    Steps.prototype.selectNewTab = function(direction) {

        var selectedTab = this.stepList.querySelector('[aria-selected="true"]');

        var index = Util.getIndexInArray(this.triggers, selectedTab);
        
        index = (direction == 'next') ? index + 1 : index - 1;

        if(index < 0) index = this.listItems.length - 1;

        if(index >= this.listItems.length) index = 0;

        this.triggerTab(this.triggers[index]);

        this.triggers[index].focus();
    };

    Steps.prototype.triggerTab = function(tabTrigger, event) {

        var self = this;

        event && event.preventDefault();

        var index = Util.getIndexInArray(this.triggers, tabTrigger);

        if(this.triggers[index].getAttribute('aria-selected') == 'true') {
            return;
        }

        Util.removeClass(this.element, 'tabs--no-interaction');

        for( var i = 0; i < this.triggers.length; i++) {

            var bool = (i == index);

            Util.toggleClass(this.panels[i], this.hideClass, !bool);

            if(this.customShowClass) Util.toggleClass(this.panels[i], this.customShowClass, bool);

            this.triggers[i].setAttribute('aria-selected', bool);

            bool ? this.triggers[i].setAttribute('tabindex', '0') : this.triggers[i].setAttribute('tabindex', '-1');
        }

        this.setProgress(index);
    };

    function navigateNext(event, layout) {

        if(layout == 'horizontal' && (event.keyCode && event.keyCode == 39 || event.key && event.key == 'ArrowRight')) { 
            return true;

        } else if(layout == 'vertical' && (event.keyCode && event.keyCode == 40 || event.key && event.key == 'ArrowDown')) { 
            return true;

        } else { 
            return false; 
        }
    };

    function navigatePrev(event, layout) {

        if(layout == 'horizontal' && (event.keyCode && event.keyCode == 37 || event.key && event.key == 'ArrowLeft')) { 
            return true; 

        } else if(layout == 'vertical' && (event.keyCode && event.keyCode == 38 || event.key && event.key == 'ArrowUp')) { 
            return true; 

        } else { 
            return false; 
        }
    };

    window.Steps = Steps;

    var steps = document.getElementsByClassName('js-steps');

    if(steps.length > 0) {

        for(var i = 0; i < steps.length; i++) {
            (function(i){new Steps(steps[i]);})(i);
        }
    }
}());